/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { isStringNotEmpty, isTrue, isArrayNotEmpty } from "utils/empty-exists";
import { useSelector } from "react-redux";
import { getIcon } from "cms/icons/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavigationListSectionItem = (props) => {
    
    const item = props?.item;
    const webpage = props?.webpage;
    const guid = item?.quid;
    const nav_title = item?.nav_title;
    const _icon = item?.icon;
    const description = item?.description;
    const children = item?.children;
    const { parent } = webpage;
    const hasParent = !!parent;
    const website = useSelector((state) => state.website.current);
    const { home } = website || {};
    const isSection = hasParent && (parent === home);
    const prefix = "far";
    const icon = getIcon(prefix, _icon);
    
    return (
        <Fragment>
            <div className='simplicity-section-list-item'>
                <a href={`/composer/${guid}`}>
                    <div className="simplicity-section-list-item-title">
                        {/*  Font Awesome icon */}
                        <div className="simplicity-section-list-item-icon">
                            {isStringNotEmpty(_icon) && icon &&
                                <FontAwesomeIcon icon={icon} />
                            }
                        </div>
                        <div className="simplicity-section-list-item-text">
                            {nav_title}
                        </div>
                    </div>
                </a>

                {isTrue(isSection) &&
                    <>
                        <div className='simplicity-section-list-item-description'>
                            {description}
                        </div>
                        {isArrayNotEmpty(children) && (
                            <>
                                <div className='simplicity-section-list-item-children'>
                                    {children.map((item, index) => {
                                        const { guid, nav_title } = item;
                                        return (
                                            <div key={`${guid}${index}`} className='simplicity-section-list-item-child-item'>
                                                <a href={`/composer/${guid}`}>{nav_title}</a>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </>
                }
            
            </div>
        </Fragment>
    );
};

export { NavigationListSectionItem };

// NOTE: This display component is only suitable for Composer in the Admin Console.
//       It has links to composer in it.
